import * as tslib_1 from "tslib";
import { IgCollection } from "igniteui-react-core";
import { SyncableObservableCollection$2 } from "igniteui-react-core";
import { Base } from "igniteui-react-core";
var IgrGridSelectedItemsCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrGridSelectedItemsCollection, _super);
    function IgrGridSelectedItemsCollection(list) {
        var _this = _super.call(this) || this;
        if (list) {
            for (var i = 0; i < list.length; i++) {
                _this.add(list[i]);
            }
        }
        return _this;
    }
    IgrGridSelectedItemsCollection.prototype._createInnerColl = function () {
        var coll = new SyncableObservableCollection$2(Base.$type, Base.$type, 0);
        coll.compare = function (ext, int) {
            var comp = ext;
            if (comp.equals) {
                return comp.equals(int);
            }
            return comp === int;
        };
        coll.createTo = function (ext) {
            return ext;
        };
        coll.createFrom = function (int) {
            return int;
        };
        return coll;
    };
    return IgrGridSelectedItemsCollection;
}(IgCollection));
export { IgrGridSelectedItemsCollection };
//# sourceMappingURL=igr-grid-selected-items-collection.js.map
